import { ShieldCheck } from "lucide-react";

const LABELS = {
  education: "Uddannelse",
  certificate: "Certifikat",
  authorization: "Autorisation",
  affiliation: "Virksomhed",
  other: "Faglig kvalifikation",
};

export default function VerifiedQualifications({ claims = [] }) {
  if (!claims.length) return null;
  return (
    <section className="mt-6" data-testid="verified-qualifications">
      <h2 className="font-display text-lg font-semibold text-brand-ink">Verificerede oplysninger</h2>
      <div className="mt-2 grid gap-3 sm:grid-cols-2">
        {claims.map((claim) => (
          <article key={claim.id || claim.title} className="card-outline p-4">
            <div className="font-mono text-[10px] uppercase tracking-widest text-brand-muted">{LABELS[claim.type] || LABELS.other}</div>
            <div className="mt-1 font-semibold text-brand-ink">{claim.type === "affiliation" ? claim.company_name || claim.title : claim.title || claim.label}</div>
            {claim.type !== "affiliation" && (claim.company_name || claim.issuer) && <div className="mt-1 text-sm text-brand-body">{claim.company_name || claim.issuer}</div>}
            {claim.cvr_number && <div className="mt-1 text-sm text-brand-body">CVR: {claim.cvr_number}</div>}
            {claim.company_role && <div className="mt-1 text-sm text-brand-body">Rolle: {claim.company_role}</div>}
            {claim.authorization_number && <div className="mt-1 text-sm text-brand-body">Aut.nr.: {claim.authorization_number}</div>}
            {claim.type === "affiliation" && claim.issuer && claim.issuer !== claim.company_name && <div className="mt-1 text-sm text-brand-body">Dokumentation fra: {claim.issuer}</div>}
            <div className="mt-2 inline-flex items-center gap-1 text-xs font-medium text-brand-fresh"><ShieldCheck size={13}/> Verificeret af SpørgMig</div>
          </article>
        ))}
      </div>
    </section>
  );
}

